export const SELECT = 'SELECT';
export const TEXT = 'TEXT';
export const TEXTS = 'TEXTS';
export const DATE_TIME = 'DATE_TIME';
export const FLAT_RADIO = 'FLAT_RADIO';
export const BOOLEAN = 'BOOLEAN';
export const EXTERNAL = 'EXTERNAL';
export const RADIO = 'RADIO';
